import React from 'react';
import { Polyline as EPolyline } from './external/Polyline';

const DASH_ICONS = [
  {
    icon: {
      // A 1×2 vertical line — the pattern below repeats it every 16px,
      // producing a dashed stroke.
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      scale: 3,
    },
    offset: '0',
    repeat: '16px',
  },
];

const Polyline = ({ route }) => {
  // Two ways to describe the path, in priority order:
  //   1. `route.polyline`  → Google encoded polyline string
  //   2. `route.path`      → array of { lat, lng } points (used for short
  //                          ad-hoc segments like the OVO-109 driver
  //                          "in-transit" connector)
  const props = {
    strokeWeight: route.strokeWeight ?? 4,
    strokeColor: route.color || '#4F8CE0',
  };
  if (route.dashed) {
    // strokeOpacity:0 hides the continuous line; the icons array draws the
    // dashes on top, giving a clean dashed-line look.
    props.strokeOpacity = 0;
    props.icons = DASH_ICONS;
  } else if (route.strokeOpacity != null) {
    props.strokeOpacity = route.strokeOpacity;
  }
  if (Array.isArray(route.path) && route.path.length > 0) {
    props.path = route.path;
  }
  return <EPolyline encodedPath={route.polyline} {...props} />;
};

export default Polyline;
